<template>
  <vs-table hover-flat v-if="smalls && smalls.length" :data="smalls" class="table-configuration-consultations-smalls-list">
    <template slot="thead">
      <vs-th v-text="$t('smalls.table.no')"></vs-th>
      <vs-th v-text="$t('smalls.table.company')"></vs-th>
      <vs-th v-text="$t('smalls.table.big')"></vs-th>
      <vs-th v-text="$t('smalls.table.small')"></vs-th>
      <vs-th class="text-center" v-text="$t('smalls.table.status')"></vs-th>
      <vs-th v-text="$t('smalls.table.code')"></vs-th>
      <vs-th class="text-center" v-text="$t('smalls.table.action')"></vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
        <vs-td v-text="tr.count" :data-tr-title="$t('smalls.table.no')"></vs-td>
        <vs-td v-text="tr.company_name" :data-tr-title="$t('smalls.table.company')"></vs-td>
        <vs-td :data-tr-title="$t('smalls.table.big')">
          <select v-model="tr.big_type_id" class="vs-inputx vs-input--input normal hasValue" style="width:240px;" v-if="tr.edit == true">
            <option v-for="(option, key) in bigs" :key="'bigs_' + key" :value="option.value">{{ option.label }}</option>
          </select>&nbsp;

          <validation-error :model-error="tr.smallFormErrors.big_type_id"></validation-error>
          <span v-if="tr.edit == false">{{ tr.big_type_name }}</span>
        </vs-td>
        <vs-td :data-tr-title="$t('smalls.table.small')">
          <vs-input :placeholder="$t('small')" v-model="tr.name" class="w-full" v-if="tr.edit == true"/>
          <validation-error :model-error="tr.smallFormErrors.name"></validation-error>
          <span v-if="tr.edit == false">{{ tr.name }}</span>
        </vs-td>
        <vs-td class="tr-flex-align-left-on-mobile">
          <div class="flex justify-center">
            <vs-switch v-model="tr.is_active" @click.prevent="$emit('customClickStatus', indextr, tr.id)">
              <span slot="on">{{ $t('active') }}</span>
              <span slot="off">{{ $t('inactive') }}</span>
            </vs-switch>
          </div>
        </vs-td>
        <vs-td v-text="tr.id" :data-tr-title="$t('smalls.table.code')"></vs-td>
        <vs-td>
          <div class="flex justify-center">
            <template v-if="tr.edit == true">
              <save-button @click="$emit('customClickSave', indextr, tr.id)" :id="'updateConfigurationSmallButton' + tr.id"></save-button>&nbsp;
              <cancel-button @click="$emit('customClickCancel', indextr, tr.id)"></cancel-button>
            </template>
            <template v-if="tr.edit == false">
              <edit-button @click="$emit('customClickEdit', indextr, tr.id)"></edit-button>&nbsp;
              <delete-button @click="$emit('customClickDelete', indextr, tr.id)"></delete-button>
            </template>
          </div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
  <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
    <div v-text="$t('no_record')"></div>
  </vs-alert>
</template>

<script>
export default {
  name: 'Shared.Configuration.Consultation.Smalls.List',
  props: {
    smalls: {
      type: [Object, Array],
      required: true
    },
    bigs: {
      type: [Object, Array],
      required: true
    }
  }
}
</script>

<style lang="scss">
  .table-configuration-consultations-smalls-list {
    tr {
      th {
        &:nth-child(1) { width: 5%; }
        &:nth-child(2) { width: 10%; }
        &:nth-child(3) { width: 25%; }
        &:nth-child(4) { width: 25%; }
        &:nth-child(5) { width: 10%; }
        &:nth-child(6) { width: 10%; }
        &:nth-child(7) { width: 15%; }
      }

      th,
      td {
        vertical-align: middle;
      }
    }
  }
</style>
